import { useLazyQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import ProtectedRoutes from '../AllRoutes/ProtectedRoutes';
import PublicRoutes from '../AllRoutes/PublicRoutes';
import Preloader from '@/atoms/Preloader/Preloader';
import { GET_CHATWOOT_DATA } from '@/graphql/chatwoot';
import { unwrap } from '@/graphql/federation/unwrap';
import useAnalytics from '@/hooks/useAnalytics';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
const EntryPoint = () => {
    const { checkAuth, setChatwoot } = useAppDispatch();
    const { companyId, user, pending, error, settings } = useAppSelector((state) => state.auth);
    const isLogin = companyId && (user === null || user === void 0 ? void 0 : user.id);
    const isLoginAndBlocked = error === 'BLOCKED_AUTHORIZED';
    const [getChatwootData, { error: errorChatwoot, loading, data }] = useLazyQuery(GET_CHATWOOT_DATA);
    useAnalytics();
    useEffect(() => {
        checkAuth();
    }, []);
    useEffect(() => {
        if (!isLogin)
            return;
        try {
            if (settings === null || settings === void 0 ? void 0 : settings.chatwootEnabled) {
                void getChatwootData();
            }
        }
        catch (_a) {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch chatwoot data');
        }
    }, [isLogin, user]);
    useEffect(() => {
        if (data && !errorChatwoot && !loading) {
            const chatwootResult = unwrap(data, 'driverBackOffice');
            setChatwoot(chatwootResult === null || chatwootResult === void 0 ? void 0 : chatwootResult.getChatwootData);
        }
    }, [data]);
    useEffect(() => {
        if ((user === null || user === void 0 ? void 0 : user.id) && companyId) {
            ReactGA.set({ userId: user.id });
            ReactGA.gtag('set', 'user_properties', {
                company_id: companyId,
                company_name: settings === null || settings === void 0 ? void 0 : settings.companyName
            });
        }
    }, [user, companyId]);
    if (pending) {
        return React.createElement(Preloader, null);
    }
    return React.createElement(React.Fragment, null, isLogin ? React.createElement(ProtectedRoutes, null) : React.createElement(PublicRoutes, { isLoginAndBlocked: isLoginAndBlocked }));
};
export default EntryPoint;
